import React from 'react';
import { useLocation } from 'react-router-dom';
import { logoutUrl } from '../config/routes.config';
export function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
// True for most mobile and hybrid devices
export function isDeviceTouch() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
export const redirectToLogOut = () => {
    window.location.href = logoutUrl[process.env.CONFIG_ENV || 'qa'];
};
